module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword "), _c('i', [_vm._v("by Miroslav Volf")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_vm._v("Prologue: The Story Behind the Text")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1. From the Common Image to the Common Good")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s1"
    }
  }, [_vm._v("From Belief to the Practice of the Common Good")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s2"
    }
  }, [_vm._v("The Memory of a World Illuminated by the Divine Face")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s3"
    }
  }, [_vm._v("Creation, Incarnation, and Redemptive World-Mending")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s4"
    }
  }, [_vm._v("Making the Divine Community Visible in the Cosmos")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s5"
    }
  }, [_vm._v("Pentecost and the Church as the Icon of the Trinity on Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. From the Iconoclasm of Violence to Love as the Life of the New Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genesis’s First Account of Fratricide in Light of the Iconoclasm of Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture’s Correlation between Violence and “Limited Goods”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Call to Responsibility for the Other amidst a Violent World")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Equality, Justice, and Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Recovering of Eucharistic Being in a Market-Shaped World")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World as Eucharistic Sacrament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Priests and Stewards of the Cosmos in the Eucharistic Economics of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eucharist as Pedagogy of Disciplining Desires and an Antidote to Consumerism")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness and Moral Economic Responsibility")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. From Forgiveness to the Common Good in the Spirit’s World-Mending")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit’s Artistry of Unconditional Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgiveness and the Redemption of Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Challenge of Forgiving the Unforgivable")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and Legislated Forgiveness as a Civic Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Challenge of “The Ways of Peace”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Toward a Hagiography of a Community Committed to the Common Good")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "eps19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pondering the Distinctives of Hagiographic Discourse and Saintly Lives")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "eps20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Love Visible in the Midst of War")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "eps21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#s21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Thoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture Citations")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0